import imagePlaceholder from 'assets/Wide Image 2.png';
import genericAdditionalPlaceholder from 'assets/genericAdditionalPlaceholder.png';

export const imgPlaceholders = {
  0: imagePlaceholder,
  1: genericAdditionalPlaceholder,
};
